import type { ClassDefinition } from '../../shared/game/class-types.js';

// The Cheat 3.0 draft, level 1. Cheat (level 2), subclasses and Underhanded Abilities are not implemented yet.
export const cheat: ClassDefinition = {
  id: 'cheat', name: 'Cheat',
  summary: 'A streetsmart rogue who fights dirty: high burst damage from sneaky crits, then gone before the blow lands.',
  keyStats: ['dexterity', 'intelligence'], hitDie: 6, startingHp: 10,
  saves: { advantage: ['dexterity'], disadvantage: ['will'] },
  armor: ['leather'], weapons: ['dexterity'],
  startingGear: ['Daggers (2)', 'Sling', 'Cheap Hides', 'Chalk'], defaultStance: 'skirmisher',
  abilities: [],
  passives: [
    { id: 'sneak-attack', name: 'Sneak Attack', level: 1, description: 'Once per round, when you crit, deal +1d6 damage.' },
    {
      id: 'vicious-opportunist', name: 'Vicious Opportunist', level: 1,
      description: 'Once per round, when you hit a Distracted foe with a melee attack, the hit becomes a crit. A foe is Distracted while another hero is in melee with it or it is Taunted by an ally.',
    },
  ],
};
